import { Component, OnInit } from '@angular/core'
import { SecurityQuestionService } from '../../../api/services/security-question.service'
import { SecurityQuestions } from '../../../api/models/security-questions'
import { MessageService, ConfirmationService, LazyLoadEvent, SortEvent } from 'primeng/api'
import { ActivatedRoute, Router } from '@angular/router'
import { DataPageOfSecurityQuestions } from '../../../api/models/data-page-of-security-questions'
import { FormControl, FormGroup } from '@angular/forms'
import { Customsort } from '../../directives/customsort'

@Component({
  selector: 'app-manage-questions',
  templateUrl: './manage-questions.component.html',
  styleUrls: ['./manage-questions.component.css'],
})
export class ManageQuestionsComponent implements OnInit {
  cols: { field: string; header: string }[]
  questions: DataPageOfSecurityQuestions
  selectedQuestion: SecurityQuestions
  updateQuestion: boolean
  question: SecurityQuestions = {}
  questionOperation: string
  rows: number
  showRecords: boolean
  currentPage: number = 1
  first: number = 0 // Variable to track the first record

  constructor(
    private securityQuestions: SecurityQuestionService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
      private confirmation: ConfirmationService,
      private customsort: Customsort,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: 'questionDescriptions', header: 'Question Descriptions' },
      //{field: 'edit', header: 'Edit'},
      //{field: 'delete', header: 'Delete'}
    ]

    //this.route.data.subscribe(val => {
    //    debugger;
    //    console.log('Security Question ', val);
    //    if (val['questionList']) {
    //        this.questions = val['questionList'];
    //    }
    //}, err => {
    //    console.error(err);
    //    this.questions.data = [];
    //});

    this.getQuestionList(1, '', '')
  }

  //nextPage($event: LazyLoadEvent) {
  //    debugger
  //    console.log($event);
  //    let nextPage = $event.first / $event.rows + 1;
  //    var order = "Asc";
  //    if ($event.sortOrder == -1) {
  //        order = "Desc";
  //    }
  //    if ($event.first == 0) {
  //        this.getQuestionList(1, $event.sortField, order);
  //        this.currentPage = 1;
  //    }
  //    else {
  //        this.getQuestionList(nextPage, $event.sortField, order);
  //        this.currentPage = nextPage;
  //    }

  //    this.getQuestionList(1, '', '');
  //}

  getQuestionList( pageNumber: number, sortcolumn: string, sortorder: string ): void {
    debugger
    if (sortcolumn == '' && sortorder == '') {
        sortcolumn = 'questionDescriptions'
        sortorder = 'Asc'
    }

    this.securityQuestions
      .securityQuestionGet({
        pageSize: 10,
        pageNumber: pageNumber,
      })
      .subscribe((res) => {
        debugger
        this.questions = res
        this.rows = this.questions.pageSize
        debugger
        if (this.questions.totalRecords > 0) {
            this.showRecords = true
        } else {
            this.showRecords = false
          }

         

      })
  }

  onAddQuestion(): void {
    console.log('onAddQuestion called')
    // this.question.description = '';
    this.updateQuestion = true
    this.questionOperation = 'Create Question'
    this.question = {}
  }

  onEdit(q: SecurityQuestions): void {
    console.log('onEdit Called id ', q.questionId)
    let question = { ...q }
    this.question = question
    this.updateQuestion = true
      this.questionOperation = 'Update Question'
  }

  onDelete(questionId: number): void {
    console.log('onDelete Called id ', questionId)
    if (questionId) {
      this.securityQuestions
        .securityQuestionDelete({
          id: questionId,
        })
        .subscribe(
          (val) => {
            if (val) {
              this.updateQuestion = false
              //this.router.navigateByUrl(this.router.url, /* Removed unsupported properties by Angular migration: relativeTo. */ {});
                this.messageService.add({
                    key: 'alertToast',
                severity: 'success',
                    summary: 'Confirmation',
                    detail: `Question Is Deleted Successfully`,
              })

              this.resetPage()
              this.getQuestionList(1, '', '')
            }
          },
          (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Couldn\'t Delete Question`,
            })
          },
        )
    }
  }
  dropQuestion(event: Event, QuestionId: number) {
    if (event.defaultPrevented) return
    event.preventDefault()

    this.confirmation.confirm({
      key: 'delete_confirmation',
      message: 'Are you sure you want to delete this Question?',
      accept: () => {
        this.onDelete(QuestionId)
      },
    })
  }
  saveQuestion(question: SecurityQuestions): void {
    if (
      !question.description ||
      (question.description && question.description.length === 0)
    ) {
        this.messageService.add({
            key: 'alertToast',

        severity: 'error',
        summary: 'No question description provided',
        detail: 'cannot save question with no description',
      })
      return
    }

    if (!question.questionId) {
      this.securityQuestions
        .securityQuestionPost({
          body: question,
        })
        .subscribe(
          (val) => {
            if (val) {
                this.messageService.add({
                    key: 'alertToast',
                severity: 'success',
                summary: 'Confirmation',
                detail: `Question Created Successfully.`,
              })
              this.updateQuestion = false
              //this.router.navigate([this.router.url], {relativeTo: this.route});
              debugger
              //this.currentPage = 1;
              this.getQuestionList(this.currentPage, '', '')
              //this.resetToFirstPage();
            }
          },
          (err) => {
            this.messageService.add({
              severity: 'error',
                summary: 'ERROR',
                detail: `Error While Creating Question`,
            })
            console.error(err)
          },
        )
    } else {
      this.securityQuestions
        .securityQuestionPut({
          id: question.questionId,
          body: question,
        })
        .subscribe(
          (val) => {
            if (val) {
                this.messageService.add({
                    key: 'alertToast',

                severity: 'success',
                    summary: 'Confirmation',
                    detail: `Question Edited Successfully `,
              })
              this.updateQuestion = false
              //this.router.navigate([this.router.url], { relativeTo: this.route });
              debugger
              //this.currentPage = 1;
              this.getQuestionList(this.currentPage, '', '')
              //this.resetToFirstPage();
            }
          },
          (err) => {
              this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: 'ERROR',
                  detail: `Error While Editing Question`,
            })
            console.error(err)
          },
        )
    }
  }

  nextPage($event: LazyLoadEvent) {
      debugger

      alert($event);
    console.log($event)
    let nextPage = $event.first / $event.rows + 1
    var order = 'Asc'
    if ($event.sortOrder == -1) {
      order = 'Desc'
    }
    if ($event.first == 0) {
      this.getQuestionList(1, $event.sortField, order)
      //this.currentPage = 1;
    } else {
      this.getQuestionList(nextPage, $event.sortField, order)
      //this.currentPage = nextPage;
    }

    this.currentPage = Math.floor($event.first / $event.rows) + 1
  }

  resetToFirstPage() {
    this.currentPage = 0
    this.first = 0 // Reset the first record to 0
    this.nextPage({
      first: 0,
      rows: this.rows,
      sortField: '',
      sortOrder: 0,
    })
  }

  resetPage() {
    this.first = 0 // Set the paginator to the first page
    }


    /**
   *
   * This method sort by Asce or Desc or toggle it the columns fields.
   *
   * paramOuter:: [SortEvent,num]
   * returns ::   [AllergyArray]
   *
   */
    customSort(event: SortEvent, num: number) {
       // alert(event.field)
        this.questions.data = this.customsort.generalcustomSort( event, this.questions.data)
    }
}
